module.exports = __webpack_public_path__ + "static/media/DownloadIcon.4b11ffa7.svg";